// export const API_URL = 'http://localhost:8081';

export const API_URL = 'https://api.baloo.org';
export const WAITLIST_API_URL = 'https://us-central1-baloo-waitlist-api.cloudfunctions.net/api_V1';



// WEBPACK FOOTER //
// ./src/actions/urls.js